import { Box, Typography } from '@material-ui/core'
import React from 'react'

const variantBgColors = {
  'warning': '#eee0d0',
  'success': '#e4f5e2',
  'danger': '#fae6e8',
}

const variantTypographyColors = {
  'warning': '#ce6b17',
  'success': '#338218',
  'danger': '#c83552',
}
export const StatusBadge = ({ variant = 'success', children, ...props }) => {
  return (
    <Box
      component="span"
      py="2px"
      px="8px"
      display="inline-flex"
      borderRadius="14px"
      maxHeight="50px"
      sx={{ '&': { backgroundColor: variantBgColors[variant] } }}
      {...props}
    >
      <Typography
        variant="body1"
        style={{ color: variantTypographyColors[variant] }}
      >
        {children}
      </Typography>
    </Box>
  )
}
